export default __webpack_public_path__ + "static/media/D'oùVientCelaBelle-ClaudindeSermisy.b678a094.mp3";